export const REFERENCE_SHEET_MODAL_WIDTHS = {
  expanded: '1024',
  collapsed: '380',
};

//Half of the draggable button width
export const BUTTON_WIDTH = 42;
export const HALF_BUTTON_WIDTH = BUTTON_WIDTH / 2;

export const MOVING_MODAL_GAP = 20;
